import { render, staticRenderFns } from "./ResponseMessage.vue?vue&type=template&id=2c4d2c7d&scoped=true&"
import script from "./ResponseMessage.vue?vue&type=script&lang=js&"
export * from "./ResponseMessage.vue?vue&type=script&lang=js&"
import style0 from "./ResponseMessage.vue?vue&type=style&index=0&id=2c4d2c7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4d2c7d",
  null
  
)

export default component.exports